const statusVariantMap = {
  pending: "pending",
  compliant: "success",
  warning: "warning",
  under_monitoring: "error",
  no_status: "neutral"
}

const statusIconMap = {
  pending: "bh_vamp_clock",
  compliant: "bh_vamp_check",
  warning: "bh_vamp_error",
  under_monitoring: "bh_vamp_error",
  no_status: "bh_vamp_lock"
}

export const getStatusIcon = (status) => ({
  icon: statusIconMap[status] || "bh_vamp_lock",
  variant: statusVariantMap[status] || "neutral"
})
